const UNITS = {
    SURVEY_FOOT: 0.3048006096,
    FOOT: 0.3048,
    METER: 1,
    KILOMETER: 1000,
    MILE: 1609.344
};

export default class DistanceUnitUtil {
    readonly units = UNITS;

    /**
     * 
     * @param unit 
     * @param value 
     * 
     * @returns 
     */
    toMeters(unit: string, value: number): number {
        const units = UNITS[unit];
        return value * units;
    }
    
    /**
     * 
     * @param unit 
     * @param value 
     * 
     * @returns 
     */
    fromMeters(unit: string, value: number): number {
        const units = UNITS[unit];
        return value / units;
    }
    
    /**
     * 
     * @param fromUnit 
     * @param toUnit 
     * @param value 
     * 
     * @returns 
     */
    transform(fromUnit: string, toUnit: string, value: number): number {
        return this.fromMeters(toUnit, this.toMeters(fromUnit, value));
    }
}
